"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InviteClientModal = InviteClientModal;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("@heroui/react");
var react_2 = require("react");
var industries_1 = require("../../../constants/industries");
var client_invitation_1 = require("../../../features/apis/client-invitation");
var api_error_message_1 = require("../../../utils/api-error-message");
var validation_1 = require("../../../utils/validation");
var button_component_1 = require("../../ui/button-component");
var text_component_1 = require("../../ui/text-component");
function InviteClientModal(props) {
    var _this = this;
    var isOpen = props.isOpen, onClose = props.onClose, onInvited = props.onInvited;
    var PLAN_OPTIONS = [
        { id: "LITE", label: "Lite" },
        { id: "PRO", label: "Pro" },
    ];
    var _a = (0, react_2.useState)(""), email = _a[0], setEmail = _a[1];
    var _b = (0, react_2.useState)(industries_1.INDUSTRY_OPTIONS[0]), industry = _b[0], setIndustry = _b[1];
    var _c = (0, react_2.useState)(""), plan = _c[0], setPlan = _c[1];
    var _d = (0, react_2.useState)(""), discountCode = _d[0], setDiscountCode = _d[1];
    var _e = (0, react_2.useState)(""), error = _e[0], setError = _e[1];
    var _f = (0, client_invitation_1.useInviteClientMutation)(), inviteClient = _f[0], isInviting = _f[1].isLoading;
    var requestTokenRef = (0, react_2.useRef)(0);
    // A synchronous lock also catches a second click before React renders the mutation's loading state.
    var requestInFlightRef = (0, react_2.useRef)(false);
    (0, react_2.useEffect)(function () { return function () {
        requestTokenRef.current += 1;
    }; }, []);
    var isFormComplete = !!email.trim() && !!industry.trim() && !!plan;
    var resetForm = function () {
        setEmail("");
        setIndustry(industries_1.INDUSTRY_OPTIONS[0]);
        setPlan("");
        setDiscountCode("");
        setError("");
    };
    var handleClose = function () {
        if (requestInFlightRef.current || isInviting) {
            return;
        }
        requestTokenRef.current += 1;
        resetForm();
        onClose();
    };
    var handleInvite = function () { return __awaiter(_this, void 0, void 0, function () {
        var trimmedEmail, requestToken, response, requestError_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (requestInFlightRef.current || isInviting) {
                        return [2 /*return*/];
                    }
                    setError("");
                    trimmedEmail = email.trim();
                    if (!isFormComplete) {
                        setError("Please complete all required fields.");
                        return [2 /*return*/];
                    }
                    if (!(0, validation_1.isValidEmail)(trimmedEmail)) {
                        setError("Please enter a valid email address.");
                        return [2 /*return*/];
                    }
                    requestToken = requestTokenRef.current;
                    requestInFlightRef.current = true;
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, inviteClient({
                            email: trimmedEmail,
                            industry: industry.trim(),
                            plan: plan,
                            discountCode: discountCode.trim() || undefined,
                        }).unwrap()];
                case 2:
                    response = _a.sent();
                    if (requestToken !== requestTokenRef.current) {
                        return [2 /*return*/];
                    }
                    if (!response.success) {
                        setError(response.message || "Unable to send invitation. Please try again.");
                        return [2 /*return*/];
                    }
                    onInvited === null || onInvited === void 0 ? void 0 : onInvited();
                    requestInFlightRef.current = false;
                    handleClose();
                    return [2 /*return*/];
                case 3:
                    requestError_1 = _a.sent();
                    if (requestToken !== requestTokenRef.current) {
                        return [2 /*return*/];
                    }
                    setError((0, api_error_message_1.getApiErrorMessage)(requestError_1, "Unable to send invitation. Please try again."));
                    return [3 /*break*/, 5];
                case 4:
                    requestInFlightRef.current = false;
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    return ((0, jsx_runtime_1.jsx)(react_1.Modal, { isOpen: isOpen, onOpenChange: function (open) {
            if (!open)
                handleClose();
        }, children: (0, jsx_runtime_1.jsx)(react_1.Modal.Backdrop, { isDismissable: !isInviting, isKeyboardDismissDisabled: isInviting, children: (0, jsx_runtime_1.jsx)(react_1.Modal.Container, { children: (0, jsx_runtime_1.jsxs)(react_1.Modal.Dialog, { className: "sm:max-w-[480px]", children: [(0, jsx_runtime_1.jsx)(react_1.Modal.CloseTrigger, { isDisabled: isInviting, onPress: handleClose }), (0, jsx_runtime_1.jsx)(react_1.Modal.Header, { children: (0, jsx_runtime_1.jsxs)("div", { className: "flex flex-col gap-1", children: [(0, jsx_runtime_1.jsx)(text_component_1.TextComponent, { size: "large", weight: "bold", color: "dark-gray-1", label: "Invite Client" }), (0, jsx_runtime_1.jsx)(text_component_1.TextComponent, { size: "small", color: "medium-gray", label: "Send a new client an invitation with a Stripe payment link." })] }) }), (0, jsx_runtime_1.jsx)(react_1.Modal.Body, { className: "p-1", children: (0, jsx_runtime_1.jsxs)("div", { className: "flex flex-col gap-3", children: [(0, jsx_runtime_1.jsx)(react_1.TextField, { "aria-label": "Email", type: "email", value: email, onChange: setEmail, isRequired: true, children: (0, jsx_runtime_1.jsx)(react_1.Input, { placeholder: "Client email", className: "rounded-md" }) }), (0, jsx_runtime_1.jsxs)(react_1.Select, { "aria-label": "Industry", placeholder: "Choose an industry", selectedKey: industry || null, onSelectionChange: function (key) { return setIndustry(String(key !== null && key !== void 0 ? key : "")); }, children: [(0, jsx_runtime_1.jsxs)(react_1.Select.Trigger, { className: "rounded-md", children: [(0, jsx_runtime_1.jsx)(react_1.Select.Value, {}), (0, jsx_runtime_1.jsx)(react_1.Select.Indicator, {})] }), (0, jsx_runtime_1.jsx)(react_1.Select.Popover, { children: (0, jsx_runtime_1.jsx)(react_1.ListBox, { children: industries_1.INDUSTRY_OPTIONS.map(function (option) { return ((0, jsx_runtime_1.jsx)(react_1.ListBox.Item, { id: option, textValue: option, children: option }, option)); }) }) })] }), (0, jsx_runtime_1.jsxs)(react_1.Select, { "aria-label": "Plan", placeholder: "Choose a plan", selectedKey: plan || null, onSelectionChange: function (key) { return setPlan((key !== null && key !== void 0 ? key : "")); }, children: [(0, jsx_runtime_1.jsxs)(react_1.Select.Trigger, { className: "rounded-md", children: [(0, jsx_runtime_1.jsx)(react_1.Select.Value, {}), (0, jsx_runtime_1.jsx)(react_1.Select.Indicator, {})] }), (0, jsx_runtime_1.jsx)(react_1.Select.Popover, { children: (0, jsx_runtime_1.jsx)(react_1.ListBox, { children: PLAN_OPTIONS.map(function (option) { return ((0, jsx_runtime_1.jsx)(react_1.ListBox.Item, { id: option.id, textValue: option.label, children: option.label }, option.id)); }) }) })] }), (0, jsx_runtime_1.jsx)(react_1.TextField, { "aria-label": "Discount Code", value: discountCode, onChange: setDiscountCode, children: (0, jsx_runtime_1.jsx)(react_1.Input, { placeholder: "Discount code (optional)", className: "rounded-md" }) }), error && ((0, jsx_runtime_1.jsx)("div", { role: "alert", children: (0, jsx_runtime_1.jsx)(text_component_1.TextComponent, { size: "small", color: "red-600", label: error }) }))] }) }), (0, jsx_runtime_1.jsxs)(react_1.Modal.Footer, { children: [(0, jsx_runtime_1.jsx)(button_component_1.ButtonComponent, { label: "Cancel", variant: "secondary", onPress: handleClose, isDisabled: isInviting }), (0, jsx_runtime_1.jsx)(button_component_1.ButtonComponent, { label: "Send Invitation", onPress: handleInvite, isPending: isInviting, isDisabled: !isFormComplete, color: "white", backgroundColor: "primary-navy", hoverColor: "primary-navy-light" })] })] }) }) }) }));
}
